import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Zap, LayoutDashboard, Map, TrendingUp, Bell } from 'lucide-react';

/**
 * Mobile-only bottom navigation (below `lg`).
 *
 * Five destinations, matching the v2 mobile shell. The sidebar drawer still
 * carries the full navigation; this is the thumb-reachable shortlist. Rows are
 * 66px tall so every hit target clears 44px.
 */
export const MobileTabBar: React.FC = () => {
  const { t } = useTranslation();

  const tabs = [
    { to: '/daily-brief', icon: Zap, label: t('dashboard.mobileTabs.brief') },
    { to: '/dashboard', icon: LayoutDashboard, label: t('dashboard.mobileTabs.feed') },
    { to: '/region/CENTRAL', icon: Map, label: t('dashboard.mobileTabs.regions') },
    { to: '/market-insights', icon: TrendingUp, label: t('dashboard.mobileTabs.market') },
    { to: '/alerts', icon: Bell, label: t('dashboard.mobileTabs.alerts') },
  ];

  return (
    <nav className="sm-print-hide lg:hidden fixed bottom-0 inset-x-0 z-20 h-[66px] bg-white border-t border-[#EDE6DE] flex items-center px-2">
      {tabs.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center justify-center gap-[5px] py-2 min-h-[44px] transition-colors duration-150 ${
              isActive ? 'text-[#C5922E]' : 'text-[#6B7280]'
            }`
          }
        >
          <Icon size={20} strokeWidth={1.5} />
          <span className="text-[9.5px] font-semibold tracking-[.02em]">{label}</span>
        </NavLink>
      ))}
    </nav>
  );
};
